import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const BAD = new Set(["not_roadworthy", "awaiting_reinspection"]);

export function TrailerSelect({ value, disabled, onPick }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/trailer-inspections/trailers").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  if (items && !items.length) {
    return <p className="text-xs text-amber-700" data-testid="trailer-select-empty">No trailers in Plant &amp; Transport yet. Open the trailer in Plant &amp; Transport and tick "This is a trailer".</p>;
  }
  return (
    <select value={value || ""} disabled={disabled || !items} onChange={(e) => onPick(items.find((t) => t.legacy_id === e.target.value))}
      className="w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm" data-testid="trailer-select">
      <option value="">{items ? "Select trailer" : "Loading trailers…"}</option>
      {(items || []).map((t) => <option key={t.legacy_id} value={t.legacy_id}>{t.title}{t.registration ? ` · ${t.registration}` : ""}{BAD.has(t.status) ? " — DO NOT USE" : ""}</option>)}
    </select>
  );
}

export function ForkliftSelect({ value, disabled, onPick }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/forklift-checks/forklifts").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  if (items && !items.length) {
    return <p className="text-xs text-amber-700" data-testid="forklift-select-empty">No forklifts in Plant &amp; Transport yet.</p>;
  }
  return (
    <select value={value || ""} disabled={disabled || !items} onChange={(e) => onPick(items.find((t) => t.legacy_id === e.target.value))}
      className="w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm" data-testid="forklift-select">
      <option value="">{items ? "Select forklift" : "Loading forklifts…"}</option>
      {(items || []).map((t) => <option key={t.legacy_id} value={t.legacy_id}>{t.title}{t.status === "do_not_use" ? " — DO NOT USE" : ""}</option>)}
    </select>
  );
}
